// extracted by mini-css-extract-plugin
export default {"dotSpinner":"useBackdrop_dotSpinner__7nGZh","dotSpinner__dot":"useBackdrop_dotSpinner__dot__Ml5nr","pulse0112":"useBackdrop_pulse0112__hW2CV"};